import React from 'react';
import WorklistCheckmarkWrapper from './WorklistCheckmark.style';

const WorklistCheckmark = ({ checked, onClick }) => (
  <WorklistCheckmarkWrapper checked={checked} onClick={onClick}>
    <svg width="22" height="22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11 21c5.523 0 10-4.477 10-10S16.523 1 11 1 1 5.477 1 11s4.477 10 10 10z" fill="#ffffff" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 1.5a9.5 9.5 0 1 0 0 19 9.5 9.5 0 0 0 0-19zM.5 11C.5 5.201 5.201.5 11 .5S21.5 5.201 21.5 11 16.799 21.5 11 21.5.5 16.799.5 11z"
        fill="#627fff;"
      />
      <path
        className="checkmark"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.048 8.073l-7.871 7.688-4.223-4.105 2.092-2.151 2.126 2.067 5.78-5.645 2.096 2.146z"
      />
    </svg>
  </WorklistCheckmarkWrapper>
);

export default React.memo(WorklistCheckmark);
